import React, {useRef} from 'react'
import _ from 'underscore'
import {List, RowComponentProps, useListRef, useDynamicRowHeight} from 'react-window'

import OrderCard from '../orders/OrderCard.js'
import dbCodes from '../../../server/dbCodes.js'
import {Order, Reseller} from 'types/types.js'

type OrderListProps = {
    date: string
    filteredOrders: Record<string, Order>
    viewOrder: (orderId: string, fromList?: boolean) => void
    reseller: Reseller
}

const Row = ({index, style, sortedOrders, viewOrder, reseller}: RowComponentProps<{
    sortedOrders: Order[]
    viewOrder: (orderId: string, fromList?: boolean) => void
    reseller: Reseller
}>) => {
    const order = sortedOrders[index]

    return (
        <div style={style}>
            <OrderCard
                key={order._id}
                order={order}
                onClick={() => viewOrder(order._id, true)}
                reseller={reseller}
            />
        </div>
    )
}

export default function OrderList({date, filteredOrders, viewOrder, reseller}: OrderListProps) {
    const listRef = useListRef(null)

    const activeOrders = Object.values(filteredOrders).filter((order) => order.handledBy === 'reseller' && order.date === date && !order.routeId && [dbCodes.status.verwacht(), dbCodes.status.inSortering(), dbCodes.status.gereed(), dbCodes.status.onderweg()].includes(order.status))

    const sortedOrders = _.sortBy(activeOrders, (order) => {
        const hasInvalidPosition = order.addresses.some((address) => !address.position)
        if (hasInvalidPosition) {
            return '-1'
        }

        let endTime = '24:00'

        order.addresses.map((address) => {
            if (address.endTime < endTime) {
                endTime = address.endTime
            }
        })

        return endTime
    })

    const containerRef = useRef(null)

    const rowHeight = useDynamicRowHeight({
        defaultRowHeight: 80
    })

    return (
        <div style={{display: 'flex', flexDirection: 'column', flex: 1, overflowY: 'auto', width: 345}} ref={containerRef}>
            <List
                rowComponent={Row}
                rowCount={sortedOrders.length}
                rowHeight={rowHeight}
                rowProps={{sortedOrders, viewOrder, reseller}}
                listRef={listRef}
            />
        </div>
    )
}
